<template>
  <div class="personal-center">
    <!-- <header-show :title="$t('profile.personalCenter.title')" /> -->
    <div class="personal-profile" @click="handleClick('profile-detail')">
      <div class="avatar-container">
        <x-avatar :avatarUrl="userInfo.avatarUrl" :personName="userInfo.username" class="personal-avatar"></x-avatar>
      </div>
      <div class="profile-container">
        <div class="profile-name">
          {{ userInfo.username }}
        </div>
        <div class="profile-signature text-ellipsis">
          {{ userInfo.personalProfile || $t('profile.personalCenter.signature') }}
        </div>
      </div>
      <div class="link-edit">
        <x-svg-icon class="link-next" name="arrow-right-icon"></x-svg-icon>
      </div>
    </div>
    <line-text
      v-if="!_isFeishuClient"
      icon="address-icon"
      :content="currentOrg.name"
      class="link-tenant"
      link
      @click="handleClick('switch-tenant')" />
    <line-text
      icon="edit-icon"
      :content="$t('profile.personalCenter.help')"
      class="help-feedback"
      link
      @click="handleClick('help-feedback')" />
    <line-text
      icon="system-setting"
      :content="$t('profile.personalCenter.setting')"
      class="settings"
      link
      @click="handleClick('setting')" />
  </div>
</template>

<script>
// import HeaderShow from '@/components/header-show'
import XAvatar from '@/components/x-avatar/x-avatar.vue'
import LineText from '@/components/line-text/line-text.vue'
import { mapState } from 'vuex'
import ParamsCatchMixin from '@/mixin/params-catch.mixin.js'
import FeishuClientMixin from '@/mixin/feishu-client.mixin'

export default {
  components: {
    // HeaderShow,
    XAvatar,
    LineText
  },
  mixins: [ParamsCatchMixin, FeishuClientMixin],
  computed: {
    ...mapState({
      userInfo: (state) => state.authModule.userInfo,
      currentOrg: (state) => state.tenantModule.currentOrg
    })
  },
  methods: {
    handleClick(name) {
      this.$router.push({
        name: name,
        params: {
          orgId: this.orgId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.personal-center {
  width: 100%;
  height: 100%;
  // padding-top: 3.14rem;
  background: $--app-body-bgColor;
  display: flex;
  flex-direction: column;
  .personal-profile {
    display: flex;
    height: 2.86rem;
    width: calc(100% - 1.14rem);
    margin: 0.571rem 0;
    padding: 1.14rem;
    background: $--app-light-color;
    .avatar-container {
      width: 2.86rem;
      height: 2.86rem;
      padding-right: 1.14rem;
      .personal-avatar {
        width: 100%;
        height: 100%;
      }
    }
    .profile-container {
      height: 100%;
      display: flex;
      flex-direction: column;
      flex-grow: 1;
      max-width: calc(100% - 6.643rem);
      .profile-name {
        font-size: 1.143rem;
        font-weight: bold;
        height: 1.143rem;
      }
      .profile-signature {
        margin-top: 0.571rem;
        color: $--app-notice-color;
      }
    }
    .link-edit {
      display: flex;
      align-items: center;
      padding-right: .857rem;
      .link-next {
        height: 1.714rem;
        width: 1.714rem;
        color: $--app-notice-color;
      }
    }
  }
  .link-tenant {
    background: $--app-light-color;
  }
}
</style>

<style lang="scss">
.personal-center {
  .link-tenant {
    .line-right {
      max-width: calc(100% - 2.4rem);
    }
  }
}
</style>
